import axios from 'axios';
import Fuse from 'fuse.js';
export const DIRECTORY_VERSION='ccd-2024-v1';
// Presentation only: retain published town spelling/casing in the immutable source data.
export const formatTownName=value=>String(value || '').trim().toLocaleLowerCase('en-US').replace(/(^|[\s\-.'’/])(\S)/g,(_,separator,letter)=>separator+letter.toLocaleUpperCase('en-US'));
const root=(process.env.PUBLIC_URL || '').replace(/\/$/,'')+'/demo-directory/'+DIRECTORY_VERSION;
let directoryRequest;
const schoolRequests=new Map();
const normalize=value=>String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
export function prepareDirectory(data){
  if(!data || data.version!==DIRECTORY_VERSION || !Array.isArray(data.districts) || !data.districts.length)throw new Error('DIRECTORY_UNAVAILABLE');
  const districts=data.districts;
  if(districts.some(d=>!d || !/^\d{7}$/.test(d.id) || typeof d.name!=='string' || !/^[A-Z]{2}$/.test(d.state)))throw new Error('DIRECTORY_UNAVAILABLE');
  return {districts,entries:districts.map(d=>({district:d,name:normalize(d.name),text:normalize(d.name+' '+d.city+' '+d.state)})),fuse:new Fuse(districts,{keys:[{name:'name',weight:3},'city','state'],threshold:.3,ignoreLocation:true})};
}
export function loadDistrictDirectory(){
  if(!directoryRequest)directoryRequest=axios.get(root+'/districts.json',{timeout:10000}).then(({data})=>prepareDirectory(data)).catch(error=>{directoryRequest=null;throw error;});
  return directoryRequest;
}
export function searchDistricts(directory,query){
  const text=normalize(query);if(text.length<2)return [];
  const terms=text.split(' '),matches=directory.entries.filter(e=>terms.every(term=>e.text.includes(term)));
  if(matches.length)return matches.filter(e=>e.name.startsWith(text)).concat(matches.filter(e=>!e.name.startsWith(text))).slice(0,8).map(e=>e.district);
  return directory.fuse.search(text).slice(0,8).map(r=>r.item);
}
export function loadDistrictSchools(state){
  if(!/^[A-Z]{2}$/.test(state))return Promise.reject(new Error('SCHOOLS_UNAVAILABLE'));
  if(!schoolRequests.has(state))schoolRequests.set(state,axios.get(root+'/schools/'+state+'.json',{timeout:10000}).then(({data})=>{
    if(!data || data.version!==DIRECTORY_VERSION || !data.districts || Array.isArray(data.districts))throw new Error('SCHOOLS_UNAVAILABLE');
    return data.districts;
  }).catch(error=>{schoolRequests.delete(state);throw error;}));
  return schoolRequests.get(state);
}
export const emptyDistrictSelection=()=>({district:null,scope:'undecided',schoolIds:[],schools:[],estimate:null,overrides:{}});
export function directoryBookingFields(selection){
  if(!selection.district)return null;
  const hasSchools=selection.scope==='schools' && selection.schoolIds.length>0;
  return {catalogVersion:DIRECTORY_VERSION,districtId:selection.district.id,scope:hasSchools?'schools':selection.scope==='district'?'district':'undecided',schoolIds:hasSchools?[...selection.schoolIds].sort():[]};
}
export function fallbackSchoolNotes(selection,rows=selection.schools || []){
  if(!selection.district)return '';
  const names=rows.filter(r=>selection.schoolIds.includes(r.id)).map(r=>r.name);
  const scope=selection.scope==='schools' && names.length?'Schools: '+names.join('; '):selection.scope==='district'?'Schools: Entire district':'Schools: Not sure yet';
  const text='District NCES ID: '+selection.district.id+'\n'+scope;return text.length>2000?text.slice(0,1950)+'… (additional schools selected)':text;
}
